import {ReactNode} from 'react'
import {TpaConfigContextType} from './tpa-config'

export interface TpaSuppressionData {
    shouldSuppressContent: boolean
    currentAfid: string | null
    allowedAfids: string | null
}
export interface TpaBalanceConfig {
    balanceTrackerExpiryDays: number
}
export const defaultTpaConfig: TpaConfigContextType = {
    suppressionData: {
        shouldSuppressContent: false,
        currentAfid: null,
        allowedAfids: null
    },
    balanceConfig: {
        balanceTrackerExpiryDays: 60
    }
}
export interface TpaConfigProviderProps {
    serverSuppressionData: TpaSuppressionData
    serverBalanceConfig: TpaBalanceConfig
    children: ReactNode
}
